import { LocationElements } from '../../../location-element';
import { ILocationConfigUnit } from '../../../../models/location-config.interface';
import { MAP_ADDRESS_TYPES } from '../../../../../../../shared/constants/map-address-types';
import { CmxMapConfig } from '../../../../../../../shared/models/cmx-map-config/cmx-map-config';
import { ILocationMapState } from '../../../../reducers/location-map-reducer/location-map.reducer';
import { JobsiteSetCommand } from '../../../../services/commands/jobsite/jobsite-set.command';
import { JobsiteLoadAddressCommand } from '../../../../services/commands/jobsite/jobsite-load-address.command';
import { JobsiteLoadSalesAreaCommand } from '../../../../services/commands/jobsite/jobsite-load-sales-area.command';
import { JobsiteLoadAddressEffects } from '../../../../effects/jobsite-effects/jobsite-load-address-effects/jobsite-load-address.effects';
import { JobsiteLoadSalesAreaEffects } from '../../../../effects/jobsite-effects/jobsite-load-sales-area-effects/jobsite-load-address.effects';
import { ReceivingPersonsLoadEffects } from '../../../../../../../shared/modules/receiving-person/redux/effects/receiving-person-load.effects';
import { ReceivingPersonSetCommand } from '../../../../services/commands/receiving-person/receiving-person-set.command';
import { SpecialInstructionsSetCommand } from '../../../../services/commands/special-instructions/special-instructions-set.command';
import { JobsiteRenderMapEffects } from '../../../../effects/jobsite-effects/jobsite-render-map-effects/jobsite-render-map.effects';
import { JobsiteWithoutDocumentsLoadEffects } from '../../../../effects/jobsite-effects/jobsite-load-effects/jobsite-load-without-documents.effects';
import { ExperiencesLoadEffect } from '../../../../effects/experiences-effects/experiences-load.effect';

export const delivery: { fields: ILocationConfigUnit[]; mapConfig: ILocationMapState } = {
  fields: [
    {
      name: LocationElements.JOBSITE,
      visible: true,
      disabled: false,
      required: true,
      onChange: [JobsiteSetCommand, JobsiteLoadAddressCommand, JobsiteLoadSalesAreaCommand],
      dynamicEffects: [
        JobsiteWithoutDocumentsLoadEffects,
        JobsiteLoadAddressEffects,
        JobsiteRenderMapEffects,
        JobsiteLoadSalesAreaEffects,
        ExperiencesLoadEffect,
      ],
    },
    {
      name: LocationElements.RECEIVING_PERSON,
      visible: true,
      disabled: true,
      required: true,
      onChange: [ReceivingPersonSetCommand],
      dynamicEffects: [ReceivingPersonsLoadEffects],
    },
    {
      name: LocationElements.SPECIAL_INSTRUCTION,
      visible: true,
      disabled: false,
      required: false,
      onChange: [SpecialInstructionsSetCommand],
    },
  ],
  mapConfig: {
    showMap: false,
    config: new CmxMapConfig(null, MAP_ADDRESS_TYPES.JOBSITE),
  },
};
